import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import LogsOverview from "./LogsOverview"

const AdminLogs = () => {
  return (
    <SidePanelLayout
      menuName="AdminLogs"
      tabs={{
        logs: LogsOverview,
      }}
    />
  )
}

export default AdminLogs